/* eslint-disable no-undef */
/* eslint-disable no-console */
import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
import i18n from "./i18n";

Vue.config.productionTip = false;

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default global options } */);

// global mixin
Vue.mixin({
  methods: {
    $routerTo(url_hash) {
      this.$router.push(url_hash).catch(err => {
        if (err.name !== "NavigationDuplicated") {
          console.log(err);
        }
      });
    },
    $goBack() {
      this.$router.go(-1);
    },
    async $getArea() {
      this.$store.commit("setLoadingMask", true);
      let boolean = false;
      await axios
        .get("/api/area")
        .then(response => {
          console.log("get area");

          localStorage.setItem("areas", JSON.stringify(response.data));

          boolean = true;
        })
        .catch(error => {
          console.log(error.message);
        });

      this.$store.commit("setLoadingMask", false);
      return boolean;
    },
    async $getQRcode() {
      this.$store.commit("setLoadingMask", true);
      let boolean = false;
      await axios
        .get("/api/qrcode")
        .then(response => {
          console.log("get qrcode");

          localStorage.setItem("qrcodes", JSON.stringify(response.data));

          boolean = true;
        })
        .catch(error => {
          console.log(error.message);
        });

      this.$store.commit("setLoadingMask", false);
      return boolean;
    },
    async $uploadFile(form_data) {
      console.log(form_data.get("img"));
      let res = "";
      await axios
        .post("/upload/image", form_data)
        // .get("/api/upload", form_data) //測試
        .then(response => {
          res = response.data;
        })
        .catch(error => {
          console.log(error.message);
          res = "";
        });
      return res;
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.roles.includes(store.state.role)) {
    next();
  } else {
    alert("請登入");
    next({ path: "/Home" }); //跳到404页面
  }
});

// 圖片家載錯誤
document.addEventListener(
  "error",
  function(e) {
    var elem = e.target;
    if (elem.tagName.toLowerCase() === "img") {
      elem.src = require("../public/images/front-img1.png");
    }
  },
  true
);

i18n.locale = "zh-TW";

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
